<template>
	<div>
		<template v-if="treatmentsession.id">
			<template v-if="feedbacksubmitted">
				<div class="abs-center text-center">
					<h2>{{ $t('thank-you-for-your-feedback') }}</h2>
					<button class="btn btn-primary" @click="done">
						{{ $t('continue') }}
					</button>
				</div>
			</template>
			<template v-else>

				<template v-if="$config.getValue('requeststudentfeedback')">
					<template v-if="feedbacknotavailable">
						<div class="mt-4 text-center">
							<h2>{{ $t('feedback-not-available') }}</h2>
							<button class="btn btn-primary" @click="done">
								{{ $t('continue') }}
							</button>
						</div>
					</template>
					<template v-else>
						<h2>{{$t('your-feedback')}}</h2>
						<ul v-if="questions.length" class="list-unstyled">
							<li v-for="question in questions" :key="question.id">
								<FeedbackQuestion
									:question="question"
									:ref="`question-${question.id}`"
								></FeedbackQuestion>
							</li>
						</ul>
						<button class="btn btn-primary" @click="save">{{ $t('save-feedback') }}</button>
					</template>
				</template>

			</template>

		</template>
	</div>
</template>
<script>
import FeedbackQuestion from "src/components/FeedbackQuestion.vue";
export default {
	props: {},
	components: {
		FeedbackQuestion
	},
	data() {
		return {
			feedbacknotavailable: false,
			feedbacksubmitted: false,
			questions: [],
			treatmentsession: {
				id: null ,
				procedures: []
			}
		};
	},
	mounted() {
		this.getQuestions();
		this.getTreatmentSession();

	},
	computed: {},
	methods: {
		done() {
			this.$store.state.showMenu = true;
			this.$router.replace(`/clinical`);
		},
		skip() {
			this.$store.state.showMenu = true;
			this.$router.replace(`/clinical`);
		},
		save() {
			const data = {
				treatmentSessionId: this.$route.params.treatmentsessionid,
				feedbackData: []
			};

			// Extract responses and scores
			let responseId;
            let questionText;

			for (let question of this.questions) {
				responseId = this.$refs[`question-${question.id}`][0].getValue();
                questionText = this.$refs[`question-${question.id}`][0].question.text;

                const response = question.responses.filter( (res) =>  res.id == responseId);
                if (question.type == "1") {
					data.feedbackData.push(
                        { 
                            questionId: question.id, 
                            responseId: responseId, 
                            question: questionText, 
                            response: response[0].text !== "" ? response[0].text : response[0].value,
                            ResponseType: response[0].ResponseType
                        }
                    );
				} else if (question.type == "2") {
					// yuck - api expects different data structure for comments!
					data.feedbackData.push(
                        { 
                            questionId: question.id, 
                            comment: responseId, 
                            question: questionText, 
                            response: responseId, 
                            ResponseType: 1 
                        }
                    );
				}
			}

			this.$cfetch(`${this.$settings.APIBaseURL}/treatmentsessions/studentfeedback/save`, {
				method: "post",
				data: {
					data: data
				}
			})
                .then(json => {
					if (json.status === "SUCCESS") {
						this.feedbacksubmitted = true;
					} else {
						this.$log.error.call(this, "Could not save questions");
					}
				})
				.catch(error => {
					this.$log.error.call(this, error);
				});
		},
		getQuestions() {
			this.$cfetch(`${this.$settings.APIBaseURL}/treatmentsessions/studentfeedback/listquestions`, {
				method: "post",
				data: {
					id: this.$route.params.treatmentsessionid
				}
			})
				.then(json => {
					if (json.status === "SUCCESS") {
						this.questions = json.questions;
					} else {
						this.feedbacknotavailable = true;
						this.$log.error.call(this, "Could not get questions for treatment session");
						//this.done();
					}
				})
				.catch(error => {
					this.feedbacknotavailable = true;
					this.$log.error.call(this, error);
				});
		},
		getTreatmentSession() {
			this.$store.commit("showBlockingSpinner");
			this.$cfetch(`${this.$settings.APIBaseURL}/treatmentsessions/load`, {
				method: "post",
				data: {
					id: this.$route.params.treatmentsessionid
				}
			})
			.then(json => {
				this.$store.commit("hideBlockingSpinner");
				if (json.status === "SUCCESS") {
					this.treatmentsession = json.treatmentsession;
					this.addMarking();
					this.configureMarking();
					if(json.treatmentsession.hasstudentfeedback){
						this.feedbacknotavailable = true;
					}
				} else {
					this.unableToOpenTreatmentSession();
					this.$log.error.call(this, "Could not fetch treatment session");
				}
			})
			.catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.unableToOpenTreatmentSession();
				this.$log.error.call(this, error);
			});
		},
		unableToOpenTreatmentSession() {
			const self = this;
			this.$store.commit("openDialog", {
				title: this.$t("oops"),
				content: this.$t("unable-to-open-treatment-session"),
				confirmCallBack: function() {
					self.$router.replace("/clinical");
				}
			});
		},
		configureMarking() {
			this.$log.info.call(this, "Reconfiguring marking");

			var markingcriteria = null;
			if (this.$config.getValue("participationTypes")) {
				this.$config.getValue("participationTypes").forEach(participationType => {
					if (participationType.id == this.treatmentsession.typeId) {
						markingcriteria = participationType.markingcriteria;
					}
				});
			}

			for (let section in this.treatmentsession.assessment) {
				this.treatmentsession.assessment[section].display = false;
				this.treatmentsession.assessment[section].formElements.forEach(formElement => {
					if ("markingsets" in formElement) {
						formElement.display = false;
						formElement.markingsets.forEach(markingset => {
							if (markingcriteria == markingset) {
								this.treatmentsession.assessment[section].display = true;
								formElement.display = true;
							}
							/*
							if(markingset == 'all'){
								formElement.display = true;
							}
							*/
						});
					} else {
						this.treatmentsession.assessment[section].display = true;
						formElement.display = true;
					}
					if("programme" in formElement) {
						formElement.display = false;
						this.$users.getUserById.call(this, this.treatmentsession.student).then(student => {
							formElement.programme.forEach(programme => {
								if (student.programme == programme) {
									if("year" in formElement) {
										formElement.year.forEach(year => {
											if (student.year == year) {
												this.treatmentsession.assessment[section].display = true;
												formElement.display = true;
											}
										});
									} else {
										this.treatmentsession.assessment[section].display = true;
										formElement.display = true;
									}
								}
							});
						});
					}
				});
			}
		},
		addMarking() {
			// Add the formfields for the assessment screen to the treatmentsession object
			var sections = ["markingmain", "markingsummary", "markingsupp"];
			if (!("assessmentfields" in this.treatmentsession)) {
				this.treatmentsession.assessment = {
					markingmain: {
						display: false,
						formElements: []
					},
					markingsummary: {
						display: false,
						formElements: []
					},
					markingsupp: {
						display: false,
						formElements: []
					}
				};
			}
			// Iterate over the configured assessment sections. Add them into the treatment session.
			sections.forEach(section => {
				if (section in this.$config.getValue("assessmentfields")) {
					var fields = JSON.parse(
						JSON.stringify(this.$config.getValue("assessmentfields")[section])
					);
					fields.forEach(formElement => {
						if (!("value" in formElement)) {
							if (formElement.type == "textarea") {
								formElement.value = "";
							} else {
								formElement.value = false;
							}
						}
						formElement.elementid = formElement.id;
						formElement.display = true;
						formElement.requiredIncomplete = false;
						// Is there a saved value in the loaded treatment session for this item?
						if (formElement.type in this.treatmentsession) {
							if (formElement.id in this.treatmentsession[formElement.type]) {
								formElement.value = this.treatmentsession[formElement.type][
									formElement.id
								];
							}
						}
						this.treatmentsession.assessment[section].formElements.push(formElement);
					});
				}
			});

			// Add the procedure marking
			this.treatmentsession.procedures.forEach(procedure => {
				var marks = JSON.parse(JSON.stringify(procedure.marking));
				procedure.marking = {
					formElements: []
				};
				if (procedure.markingset) {
					var proceduremarking = this.$config.getValue("proceduremarking");
					if (proceduremarking) {
						proceduremarking.fields.forEach(formElement => {
							if ("markingsets" in formElement) {
								formElement.display = false;
								formElement.markingsets.forEach(markingset => {
									if (procedure.markingset == markingset) {
										var addFormElement = JSON.parse(
											JSON.stringify(formElement)
										);
										addFormElement.display = true;
										addFormElement.value = null;
										/*
										if(addFormElement.id in marks){
											addFormElement.value = marks[addFormElement.id].value;
										}
										*/
										if (addFormElement.name in marks) {
											addFormElement.value = marks[addFormElement.name].value;
										}
										procedure.marking.formElements.push(addFormElement);
									}
								});
							}
						});
					}
				}
			});
		}
	}
};
</script>
